module.exports = __webpack_public_path__ + "static/img/icon_ins.113fe03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_ins.png
// module id = SImZ
// module chunks = 0